/**
 * Gating widoczności integracji Google Ads (VP-192).
 *
 * Aplikacja nie przeszła weryfikacji Google OAuth — poza listą testerów w Google
 * Cloud Console każde podłączenie kończy się ekranem „Dostęp zablokowany"
 * (403 access_denied). Integracja jest więc niegotowa i znika z UI dla zwykłych
 * userów; zostaje widoczna dla `super_admin` oraz kont z listy testerów poniżej,
 * żeby dało się ją testować od środka na dev i na produkcji (ten sam wzorzec co
 * YouTube/LinkedIn Content Publish w centrum integracji).
 *
 * Jedno źródło prawdy dla wszystkich miejsc, które pokazują Google Ads
 * (centrum integracji, ustawienia analityki, panel w czacie, przewodnik,
 * rekomendacje, wybory źródła danych, kafelek w Ads Wizard) — wzorzec
 * z `shopify-access.ts`.
 *
 * Po przejściu weryfikacji Google: usuń wywołania tego helpera (albo zmień go na
 * `true`), integracja wraca bez odtwarzania kodu.
 */

/**
 * Konta testerów dopuszczone poza rolą `super_admin`. Muszą być równocześnie
 * na liście testerów w Google Cloud Console — inaczej OAuth i tak skończy się
 * ekranem „Dostęp zablokowany". Roli w bazie NIE podnosimy (CLAUDE.md §0).
 */
export const GOOGLE_ADS_TESTER_EMAILS: ReadonlySet<string> = new Set<string>([
  "adrian.gasek.99@gmail.com",
]);

export type GoogleAdsAccessUser = {
  role?: string | null;
  email?: string | null;
};

/** Czy user ma widzieć w UI cokolwiek związanego z integracją Google Ads. */
export function canAccessGoogleAdsIntegration(
  user: GoogleAdsAccessUser | null | undefined
): boolean {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const email = (user.email ?? "").toLowerCase();
  return email.length > 0 && GOOGLE_ADS_TESTER_EMAILS.has(email);
}
